var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGreenEye = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1051 -741)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(1051 741)",
    fill: "#85cb3f"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(863.875 598.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.123,166.851s9.6,12.049,20.25,0v-.546s-9.6-12.05-20.25,0Z",
    fill: "none",
    stroke: "#fbfdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17491.664-7899.976a3.543,3.543,0,0,1-3.539-3.539,3.541,3.541,0,0,1,3.539-3.534,3.539,3.539,0,0,1,3.535,3.534A3.541,3.541,0,0,1,17491.664-7899.976Zm-1.094-5.936a1.088,1.088,0,0,0-1.084,1.089,1.088,1.088,0,0,0,1.084,1.089,1.09,1.09,0,0,0,1.09-1.089A1.09,1.09,0,0,0,17490.57-7905.912Z",
    transform: "translate(-17282.412 8069.913)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGreenEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/green-eye.443d3a7c.svg";
export { ForwardRef as ReactComponent };